import { transformInventoryDatesToMoment } from '../../../Dates';
import Connector, { takeQuery } from '../../../agent';
import types from './types';
import { goToErrorPage } from '../../../utils';

const InventoriesHistory = {
  getInventoryHistory: ({ id }) => Connector.api.get(`/inventories/history/${id}`, false, {}),
  getInitialData: ({ id }) =>
    Connector.api.get(`/inventories/history/getInitialData/${id}`, false, {})
};

const inventoryHistorySagas = [
  takeQuery(types.GET_INVENTORY_HISTORY, {
    api: InventoriesHistory.getInventoryHistory,
    process: transformInventoryDatesToMoment,
    notifyFailure: [goToErrorPage]
  }),
  takeQuery(types.GET_INITIAL_DATA, {
    api: InventoriesHistory.getInitialData
  })
];

export default inventoryHistorySagas;
